import { Icon } from "@/components/icon/Icon";
import "./table.css";
import type { Column } from "@/types/array.types";
import Select from "@/components/select/Select";
import type { IconName } from "@/components/icon/IconName";


interface TableProps<T> {
    columns: Column<T>[];
    dataArray: T[];
    role: string
    onDelete?: (id: number) => void;
    onEdit?: (id: number) => void;
}

export function Table<T extends Record<string, any>>({columns, dataArray, role, onDelete, onEdit}: TableProps<T>) {
    return <table>
    <thead className={"table-header"}>
        <tr>
        {columns.map((column, index) => {
            return  column.key != "id" && <th key={`header_${index}`}> {column.label}</th>
        })}
        {(role == "editor" || role == "admin")  && <th>Actions</th>}
        </tr>
    </thead>
    <tbody className={"table-body"}>
        {dataArray?.map((data, rowIndex) => (
          <tr className="table-row" key={rowIndex}>
            {columns.map((column, colIndex) => 
              column.key != "id" &&
              <td onClick={() => 
                (column.key == "artist" || column.key == "document_id" || column.key == "brand") && onEdit(rowIndex)
              }
              key={colIndex} 
              className={
                (column.key == "artist" || 
                column.key == "document_id" || 
                column.key == "brand") ? "table-column-clickable" : "" }>
                 {column.render
                    ? column.render(data)
                    : String(data[column.key])}              
              </td>
            )}
             {(role == "editor" || role == "admin") && <td className="column-actions">
                <Select className="users-table-select" iconName="actions" items={[
                                  {
                                    label: "Modifier",
                                    iconName: "edit" as IconName,
                                    onClick: () => onEdit(rowIndex)
                                  },
                                  {
                                    label: "Supprimer",
                                    iconName: "delete" as IconName,
                                    onClick: () => onDelete(rowIndex)
                                  },
                  ]}/>
             </td> }
          </tr>
        ))}
      </tbody>
    </table>
    
};